// @flow
import ExperimentClient from 'app/common/lib/ExperimentsClient/index';

export default class SeoExperimentsClient extends ExperimentClient {
  v2ActivateExperiment(name: string): ?string {
    throw new Error('Not implemented by SeoExperimentsClient.');
  }
}
